import { createSelector } from "reselect";
import { sectionsSelector } from "../../sections_selector";

export const woundsSectionSelector = createSelector(
  sectionsSelector,
  sections => {
    return sections.wounds;
  }
);
